"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublishedEvents = exports.sendAnalyticsDataOnLoad = exports.dispatchTealiumEvent = exports.getPageUrl = exports.setPageUrl = exports.getPageName = exports.setPageName = exports.sendAnalyticsData = void 0;
var tealium_analytics_model_1 = require("./tealium-analytics.model");
var string_helper_model_1 = require("./utils/string-helper.model");
var utag_helper_model_1 = require("./utils/utag-helper.model");
var tealium_analytics_validator_1 = require("./tealium-analytics.validator");
var customerProfile_service_1 = require("./customerProfile-service");
/**
 * @param dataEvent Information about the event to be dispatch to tealium.
 * @param dataEvent.context Info about the application e.g. ['CheckoutFunnel']['Energy sales']
 * @param dataEvent.eventName The actual reason for the event e.g. Is electricity already supplied to address
 * @param dataEvent.signupFlowName The product being bought e.g. ['energy']['nbn']
 * @param dataEvent.extraEventData Object whose keys are separately added as custom event tags
 * @param dataEvent.error APIs or validation errors e.g. {code: '500', description: 'Internal API fault', type: 'API'}
 * @param sendOptions Options for formatting the tag data sent to tealium
 * @param sendOptions.sendOnlyNewEvents Will only send new unique combinations of event name and event data
 * @param sendOptions.shouldDecameliseEventNames Will remove the camel casing of event names e.g. isCamelCase = is camel case
 * @param sendOptions.constructEventsButDoNotPublish Will construct a tealium event but not publish it
 * @param sendOptions.tagOpen tag context + event will use this for delimiting arrays
 * @param sendOptions.tagClose tag context + event will use this for delimiting arrays
 * @param sendOptions.stringDelimeter tag context + event will use this for delimiting arrays
 */
function sendAnalyticsData(dataEvent, sendOptions) {
    if (!tealium_analytics_validator_1.isTealiumEventValid(dataEvent)) {
        // return []; // Allow invalid events to be published
    }
    var events = [];
    var options = __assign(__assign({}, defaultSendOptions), (sendOptions || {}));
    // key value pairs will be logged as seperate events
    var isEventDataKeyValuePair = !!dataEvent.eventData &&
        !Array.isArray(dataEvent.eventData) &&
        typeof dataEvent.eventData === 'object' &&
        Object.keys(dataEvent.eventData).length > 0;
    if (isEventDataKeyValuePair) {
        Object.keys(dataEvent.eventData).forEach(function (key) {
            var childEvent = __assign(__assign({}, dataEvent), { context: __spreadArrays(dataEvent.context).concat(dataEvent.eventName ? [dataEvent.eventName] : []), eventName: key, eventData: String(dataEvent.eventData[key]) });
            var keyEvent = constructTealiumEventData(childEvent, options);
            if (keyEvent) {
                events.push(keyEvent);
            }
        });
    }
    else {
        var event_1 = constructTealiumEventData(dataEvent, options);
        if (event_1) {
            events.push(event_1);
        }
    }
    if (!options.constructEventsButDoNotPublish) {
        events.forEach(function (ev) { return dispatchTealiumEvent(ev); });
    }
    return events;
}
exports.sendAnalyticsData = sendAnalyticsData;
function setPageName(name) {
    pageName = name;
}
exports.setPageName = setPageName;
function getPageName() {
    var _a;
    return pageName || ((_a = utag_helper_model_1.getUtagData()) === null || _a === void 0 ? void 0 : _a.page_name);
}
exports.getPageName = getPageName;
function setPageUrl(url) {
    pageUrl = url;
}
exports.setPageUrl = setPageUrl;
function getPageUrl() {
    var _a;
    return pageUrl || ((_a = utag_helper_model_1.getUtagData()) === null || _a === void 0 ? void 0 : _a.page_URL);
}
exports.getPageUrl = getPageUrl;
function dispatchTealiumEvent(utagEventData) {
    if (!utagEventData) {
        return;
    }
    utag_helper_model_1.getUtagQueue().push({
        run: function () {
            if (utag_helper_model_1.getUtag()) {
                utag_helper_model_1.getUtag().link(__assign({}, utagEventData));
            }
            else {
                // tslint:disable-next-line:no-console
                console.error(tealium_analytics_model_1.consoleName + ": Utag not found when trying to send analytics data event");
            }
        },
    });
}
exports.dispatchTealiumEvent = dispatchTealiumEvent;
function sendAnalyticsDataOnLoad(data) {
    utag_helper_model_1.getUtagQueue().push({
        run: function () {
            if (utag_helper_model_1.getUtag()) {
                utag_helper_model_1.getUtag().view(data);
            }
            else {
                // tslint:disable-next-line:no-console
                console.error(tealium_analytics_model_1.consoleName + ": Utag not found when trying to send analytics data on load");
            }
        },
    });
}
exports.sendAnalyticsDataOnLoad = sendAnalyticsDataOnLoad;
function getPublishedEvents() {
    return tealium_analytics_validator_1.loggedEvents;
}
exports.getPublishedEvents = getPublishedEvents;
function constructTealiumEventData(data, sendOptions) {
    var _a, _b, _c;
    var tagData = __assign(__assign({ page_name: getPageName(), page_URL: getPageUrl(), event: string_helper_model_1.buildString(data.eventName ? data.context.concat(data.eventName) : data.context, sendOptions), event_data: string_helper_model_1.buildString(data.eventData, {
            stringDelimeter: ',',
        }), signup_flow_name: string_helper_model_1.buildString(data.signupFlowName, {
            stringDelimeter: ',',
        }) }, (data.error
        ? {
            error_code: (_a = data.error) === null || _a === void 0 ? void 0 : _a.code,
            error_description: (_b = data.error) === null || _b === void 0 ? void 0 : _b.description,
            error_type: (_c = data.error) === null || _c === void 0 ? void 0 : _c.type,
        }
        : {})), (data.extraEventData ? data.extraEventData : {}));
    var customerStatus = getCustomerStatus();
    if (customerStatus) {
        tagData.signup_customerStatus = customerStatus;
    }
    if (tealium_analytics_validator_1.canDispatchTealiumEventData(tagData, data, sendOptions)) {
        if (sendOptions.logEvents || sessionStorage.debug === 'true') {
            // tslint:disable: no-console
            console.info(tealium_analytics_model_1.consoleName + ": Logging event");
            console.info(tagData);
        }
        return tagData;
    }
    return null;
}
function getCustomerStatus() {
    var customerProfile = customerProfile_service_1.customerProfileService.getCustomerProfile();
    if (customerProfile) {
        if (customerProfile.isMoving) {
            return 'Moving';
        }
        if (customerProfile.isSwitching) {
            return 'Switching';
        }
        if (customerProfile.isAddingPlan) {
            return 'Add Plan';
        }
        if (customerProfile.isChangingPlan) {
            return 'Change Plan';
        }
        if (customerProfile.isAddingProperty) {
            return 'Add another property';
        }
    }
    return null;
}
var defaultSendOptions = {
    sendOnlyNewEvents: false,
    shouldDecameliseEventNames: false,
    constructEventsButDoNotPublish: false,
    tagOpen: '[',
    tagClose: ']',
    stringDelimeter: ',',
};
var pageName = '';
var pageUrl = '';
